<template>
  <div class="home">
    <div class="columns is-centered">
      <div class="column is-half">
        <div class="logo">
          <img src="/img/agtran_logo.png" alt="">
        </div>
        <h1 class="title">Check In</h1>
        <div class="card">
          <div class="card-content">
            <div class="columns">
              <div class="column">
                <label for="reservationId" class="label">Reservation ID</label>
                <input v-model="code" class="input" type="text" placeholder="" name="reservationId">
              </div>
              <div class="column">
                <label for="icnum" class="label">IC/Passport No.</label>
                <input v-model="ic_num" class="input" type="text" placeholder="" name="icnum">
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <a href="#" @click="searchReservation()" class="card-footer-item">Search</a>
          </footer>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  // @ is an alias to /src
  import HelloWorld from '@/components/HelloWorld.vue'
  import {
    CONFIG
  } from "../config";

  export default {
    name: 'home',
    components: {
      HelloWorld
    },
    data() {
      return {
        code: null,
        ic_num: null
      }
    },
    methods: {
      searchReservation() {
        this.axios({
            url: CONFIG.api + '/checkin',
            method: 'POST',
            data: {
              code: this.code,
              ic_num: this.ic_num
            }
          })
          .then((res) => {
            if (res.data.length > 0) {
              this.$store.commit({
                type: 'saveReservation',
                data: res.data[0]
              })
              this.$router.push('/reservation');
            } else {
              alert('Cannot find reservation')
            }
          })
          .catch((err) => {
            console.error(err);
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .home {
    padding: 1em;
  }

  .card {
    border-radius: 15px;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2)
  }

  .card-footer {
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .card-content {
    padding: 2em;
    text-align: left;
  }

  .card-footer-item {
    background: #ff2352;
    color: white;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .logo {
    margin: 1em 0em 2em 0em;
  }

  @media screen and (min-width: 1100px) {
    .card-content {
      padding: 3em;
      text-align: left;
    }
  }
</style>